export const ORDER_PRICING_CONTROL_USERS = [
  '+380 (73) 060-66-00',
  '+380 (66) 511-08-04',
  '+380 (68) 486-14-16',
  '+380 (99) 096-52-33',
];
